import { defineMessages } from "react-intl";

const AFFILIATIONS_LIST = "affiliations-list";

const affiliationListMessages = defineMessages({
  empty: {
    id: `${AFFILIATIONS_LIST}.empty`,
    defaultMessage:
      "Your account is not connected with a subscribing institution."
  }
});

export default affiliationListMessages;
